import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { unwrapListResponse } from '../customer-related/customer-related.util';
import {
  CustomerAccessRow,
  recordBelongsToCustomer,
  toCustomerAccessRow,
} from '../customer-related/customer-module-rows.util';
import { CustomerRelatedListsService } from '../customer-related-lists.service';

@Component({
  selector: 'app-customer-accesses-panel',
  templateUrl: './customer-accesses-panel.component.html',
  styleUrls: ['./customer-accesses-panel.component.sass'],
})
export class CustomerAccessesPanelComponent implements OnChanges {
  @Input() customerId: string | null = null;

  rows: CustomerAccessRow[] = [];
  loading = false;
  displayedColumns = ['email', 'system', 'type'];

  constructor(
    private lists: CustomerRelatedListsService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customerId']) {
      this.load();
    }
  }

  load(): void {
    if (!this.customerId) {
      this.rows = [];
      this.loading = false;
      return;
    }
    this.loading = true;
    this.lists
      .listAccesses(this.customerId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.rows = unwrapListResponse(response)
            .filter((item) => recordBelongsToCustomer(item, this.customerId || ''))
            .map(toCustomerAccessRow);
          this.loading = false;
        },
        error: () => {
          this.rows = [];
          this.loading = false;
          this.toastService.showWarn('Não foi possível carregar os acessos deste cliente.');
        },
      });
  }

  open(row: CustomerAccessRow): void {
    if (!row?.id) return;
    this.router.navigate(['/customer-acess/view', row.id]);
  }
}
